"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var BlogList = /** @class */function () {
    // 初始化构建函数
    function BlogList() {
        this.domMapId = new Map(); //存放dom节点的id；防止存在重复渲染的dom
        this.flag = 0; //渲染数组的长度
        this.nogetmore = 0; //判断是否没有更多
        this.init();
    }
    BlogList.prototype.init = function () {
        this.renderList(); //渲染列表
        this.pageRequest();
    };
    //分批渲染函数
    BlogList.prototype.pageRequest = function () {
        var loading = document.querySelector('.loading-box');
        var scrolldown = document.querySelector(".read-more-box");
        var nomore = document.querySelector(".no-more-box");
        var that = this;
        if (that.flag == listData.length) return loading.style.display = 'none';
        var pageRequestHandle = function pageRequestHandle() {
            // 获取滚动条的位置
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            // console.log(scrollTop,windowHeight,scrollHeight)
            if (scrollTop + windowHeight >= scrollHeight - 416) {
                // console.log('nogetmore:', that.nogetmore)
                //滚动条离底部还有416px的时候触发
                if (!that.nogetmore) {
                    loading.style.display = "block";
                }
                scrolldown.style.display = "none";
                if (that.flag >= listData.length) {
                    //数组遍历完的时候
                    var timer3 = null;
                    clearTimeout(timer3);
                    timer3 = setTimeout(function () {
                        loading.style.display = "none";
                        scrolldown.style.display = "none";
                        nomore.style.display = 'block';
                        that.nogetmore = 1;
                    }, 1000); //设置显示没有更多的时间
                    return 'its the last page';
                } else {
                    var timer2 = null;
                    clearTimeout(timer2);
                    timer2 = setTimeout(function () {
                        that.renderList();
                    }, 1000); //设置定时器来显示loading时间
                }
            }
        };
        var debounce = function debounce(func, delay) {
            var timer = null;
            return function () {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    func.apply(that, arguments);
                }, delay);
            };
        };
        document.addEventListener('scroll', debounce(pageRequestHandle, 300));
    };
    BlogList.prototype.renderList = function () {
        // 渲染列表
        var listDom = document.querySelector('.classification');
        // 获取下拉加载元素
        var loading = document.querySelector(".loading-box");
        var scrolldown = document.querySelector(".read-more-box");
        // listDom.innerHTML = ''
        var that = this;
        var data = []; //存储数组中的两个元素
        for (var i = 0; i < 4; i++) {
            // data.push(listData[that.flag])
            if (listData[that.flag]) {
                data.push(listData[that.flag]);
            }
            that.flag++;
        }
        // console.log(data, that.flag)
        data.forEach(function (item) {
            if (that.domMapId.has(item.term_id)) {} else {
                that.domMapId.set(item.term_id, item.term_id);
                listDom.innerHTML += "\n                    <li>\n                        <p>".concat(item.name, "</p>\n                        <ul>\n                            ").concat(item.post.map(function (items) {
                    return "<li><a target=\"_blank\" href=\"".concat(domain, "/").concat(item.url, "/").concat(items.url, ".html\">").concat(items.post_title, "</a></li>");
                }).join(""), "\n                        </ul>\n                        <a target=\"_blank\" href=\"").concat(domain, "/").concat(item.url, "/\">Read all<img\n                                src=\"/static/index/common/imgs/blog/down_ico1.png\"\n                                alt=\"\"></a>\n                    </li>\n                ");
            }
            loading.style.display = 'none';
            scrolldown.style.display = 'block';
        });
    };
    return BlogList;
}();
exports.default = BlogList;